import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "@client.components/Icon";
import "./Button.scss";

export const Button = forwardRef(
  ({ text, icon, isSvg, onClick, className, disabled }, ref) => {
    const [isDisabled, setIsDisabled] = useState(!!disabled);

    useImperativeHandle(ref, () => ({
      setDisabled: setIsDisabled,
    }));

    return (
      <div
        ref={ref}
        className={classNames("button", { disabled: isDisabled }, className)}
        onClick={disabled ? null : onClick}
      >
        {icon && <Icon name={icon} isSvg={isSvg} />}
        {text && <span>{text}</span>}
      </div>
    );
  }
);

Button.displayName = "Button";

Button.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  isSvg: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
